export const setPortifolios = ({ portifolios }) => state => {
  return {
    ...state,
    loadingPortifolios: false,
    portifolios: portifolios || [],
  };
};
